import React, { Component } from 'react';

// Display a collection card
class CollectionCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="post-grid__item col-12 col-xl-3 col-lg-4 col-md-4 col-sm-6 sandra-entity">
        <div className="posts__item posts__item--card card">
          <figure className="posts__thumb">
            <div className="posts__cat">
              <span className="label posts__cat-label posts__cat-label--kusama">{process.env.REACT_APP_CHAIN_NAME}</span>
              <span className="label posts__cat-label posts__cat-label--category-1">RMRK</span>
            </div>
            <img src={this.props.collection.image.replace('cloudflare-ipfs.com/ipfs', 'everdreamsoft.mypinata.cloud/ipfs')} hover="collection image" className="lazy" data-src-data-src-ref="imageUrl" />
          </figure>
          <div className="posts__inner card__content">
            <a className="posts__cta posts__cta--ksm" title="Mint a new NFT" onClick={() => this.props.openMintNftForCollection(this.props.collection)}></a>
            <time className="posts__date"><span data-ref="collectionId">{this.props.collection.id}</span></time>
            <h6 className="posts__title posts__title--color-hover"><span data-ref="name">{this.props.collection.name}</span></h6>
            <div className="posts__excerpt">
              <span data-ref="description">{this.props.collection.description}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CollectionCard;